import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

const StatsBox = ({ title, number, icon, previousNumber }) => {
  const theme = useTheme();

  return (
    <Box
      sx={(theme) => ({
        padding: '16px',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '96px',
        background: 'var(--color-surface)'
      })}
    >
      <Box>
        <Typography sx={(theme) => ({ fontSize: '14px', color: theme.palette.text.secondary })}>{title}</Typography>
        <Typography sx={{ mt: '6px', fontSize: '30px', fontWeight: 600 }}>{number}</Typography>
      </Box>
      <Box
        sx={{
          height: 40,
          width: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--color-main-light-strong)',
          color: theme.palette.primary.dark,
          borderRadius: '50%'
        }}
      >
        {icon}
      </Box>
    </Box>
  );
};

export default StatsBox;
